import React, { useEffect, useState } from "react";
import ApiConnect from "../../../Utils/ApiConnect";
import NgLoading from "../NgLoading";
import { useSelector } from "react-redux";
import { Accordion, Card, useAccordionButton } from "react-bootstrap";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);
  return (
    <div className="row w-100" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}
function Purchase(props) {
  const [purchaseData, SetPurchaseData] = useState(false);
  const company = useSelector((state) => state.Auth.company);
  useEffect(() => {
    ApiConnect.get(
      `Module/SalesPurchase/Purchase/${
        props.type.toUpperCase() === "PURCHASE ENTRY"
          ? "InvoicePreview"
          : "ReturnPreview"
      }/?id=${props.id}`
    ).then((response) => {
      SetPurchaseData(response.data);
    });
  }, [props]);
  return (
    <React.Fragment>
      {purchaseData ? (
        <div className="container">
          <div className="print_invoice-header">
            <div className="row">
              <div className="col-xs-6">
                <div className="media">
                  <div className="text-center">
                    <img
                      src={company.Logo}
                      alt={company.Name}
                      width={100}
                      height={100}
                      className="media-object logo"
                    />
                  </div>
                  <ul className="media-body list-unstyled text-center">
                    <li>
                      <h3 style={{ marginBottom: "-2px" }}>{company.Name}</h3>
                    </li>
                    <li>
                      {company.Address} {company.Contact}
                    </li>
                    <li>VAT No: {company.VatPan}</li>
                  </ul>
                </div>
                <center>
                  <u>
                    <b>
                      <h3>{props.type}</h3>
                    </b>
                  </u>
                </center>
              </div>
              <div className="col-xs-6">
                <div className="panel panel-default">
                  <div className="panel-body row">
                    <ul className="media-body list-unstyled col">
                      <li>
                        Miti: {purchaseData.miti || ""}
                        <br />
                        Date: {purchaseData.date || ""}
                      </li>
                      <li>Invoice No: {purchaseData.id || ""}</li>

                      {purchaseData.vehicle ? (
                        <li>Vehicle No:{purchaseData.vehicle}</li>
                      ) : (
                        ""
                      )}
                    </ul>
                    <ul className="media-body list-unstyled col">
                      <li>
                        Name :{" "}
                        {purchaseData.account_details
                          ? purchaseData.account_details.name
                          : ""}
                      </li>
                      <li>
                        Address :{" "}
                        {purchaseData.account_details
                          ? purchaseData.account_details.address
                          : ""}
                      </li>
                      <li>
                        Phone :{" "}
                        {purchaseData.account_details
                          ? purchaseData.account_details.contact
                          : ""}
                      </li>
                      VAT No :{" "}
                      {purchaseData.account_details
                        ? purchaseData.account_details.vat
                        : ""}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
          <div className="print_invoice-body">
            <div className="row"></div>
            <div className="panel panel-default">
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th className="text-center ">Rate</th>
                    <th className="text-center ">Qty</th>
                    <th className="text-center">Free</th>
                    <th className="text-center">Sum</th>
                    <th className="text-center">Tax</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseData.particular
                    ? purchaseData.particular.map((prd, i) => (
                        <tr key={i}>
                          <td>{prd.product}</td>
                          <td className="text-right">{prd.rate}</td>
                          <td className="text-right">{prd.qty}</td>
                          <td className="text-right">{prd.free}</td>
                          <td className="text-right">{prd.gross_total}</td>
                          <td className="text-right">{prd.tax_amount}</td>
                          <td className="text-right">{prd.total}</td>
                        </tr>
                      ))
                    : ""}
                </tbody>
              </table>
            </div>
            <div className="panel panel-default">
              <table className="table table-bordered table-condensed">
                <thead>
                  <tr>
                    <td className="text-center col-xs-1">Sub Total</td>
                    <td className="text-center col-xs-1">Tax</td>
                    <td className="text-center col-xs-1">Service</td>
                    <td className="text-center col-xs-1">Discount</td>
                    <td className="text-center col-xs-1">Final</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className="text-center rowtotal mono">
                      {" "}
                      {purchaseData.subtotal || 0}
                    </th>
                    <th className="text-center rowtotal mono">
                      {purchaseData.tax_amount || 0}
                    </th>
                    <th className="text-center rowtotal mono">
                      {purchaseData.service_amount || 0}
                    </th>
                    <th className="text-center rowtotal mono">
                      {purchaseData.discount_amount || 0}
                    </th>
                    <th className="text-center rowtotal mono">
                      {purchaseData.total || 0}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="container">
              <b>In Words:</b> {purchaseData.inword || ""}
              <br />
              <i>Comments / Notes</i>: {purchaseData.note || ""}
            </div>
            <hr />
            <p className="text-center">
              {" "}
              Thank you for choosing our services.We hope to see you again soon
              <strong>~{company.Name}~</strong>
            </p>
            {purchaseData.attachment && purchaseData.attachment.length !== 0 ? (
              <Accordion>
                <Card key={1}>
                  <Card.Header>
                    <CustomToggle eventKey={1}>
                      <h4 className="col card-title">Attachments</h4>
                      <h4 className="col card-title d-flex flex-row">
                        <span className="material-icons text-success">
                          file
                        </span>
                      </h4>
                    </CustomToggle>
                  </Card.Header>
                  <Accordion.Collapse eventKey={1}>
                    <Card.Body>
                      {purchaseData.attachment.map((images, index) => (
                        <img src={images} key={index} alt={index} className="rounded" />
                      ))}
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        <NgLoading />
      )}
    </React.Fragment>
  );
}
export default React.memo(Purchase);
